import React, { useState, useEffect } from "react";
import axiosInstance from "../../Axios/axiosInstance";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Divider,
  Box,
  Snackbar,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const ClientRegistration = () => {
  const [formData, setFormData] = useState({
    ownername: "",
    address: "",
    guardianname: "",
    vehicleno: "",
    phoneno: "",
    registrationno: "",
    registrationdate: null,
    ncb: "",
    cd: "",
    engineno: "",
    chassisno: "",
    odpremium: "",
    netpremium: "",
    finalpremium: "",
    policyno: "",
    idvvalue: "",
    macmodule: "",
    startdate: null,
    expiredate: null,
    penality: "",
    // insurencedocument: null,
    taxtype: "",
  });
  const [adhardocument, setAdhardocument] = useState(null);
  const [pan, setPan] = useState(null);
  const [Rc, setRc] = useState(null);
  const [other, setOther] = useState(null);
  const [permit, setPermit] = useState(null);
  const [insurance, setInsurance] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [fitness, setFitness] = useState(null);
  const [pollution, setPollution] = useState(null);
  const [tax, setTax] = useState(null);
  const [businessType, setBusinessType] = useState("insurance");
  const [showInsuranceForm, setShowInsuranceForm] = useState(true);
  const [showFitnessForm, setShowFitnessForm] = useState(false);
  const [showPermitForm, setShowPermitForm] = useState(false);
  const [showPollutionForm, setShowPollutionForm] = useState(false);
  const [showTaxForm, setShowTaxForm] = useState(false);
  const [pollutionType, setPollutionType] = useState("");
  const [setTaxType] = useState("");
// Add a new function to handle file change and extract the file name:
const handleFileChangeAdhar = (event) => {
  const selectedFiles = event.target.files[0];
  if (selectedFiles) {
    // Set the file in the state
    setAdhardocument(selectedFiles);
  handleChange({
    target: {
      name: "adhardocument",
      value: selectedFiles,
      size: selectedFiles.size,
    },
  });
}
};
const handleFileChangePollution = (event) => {
  const selectedFiles = event.target.files[0];
  if (selectedFiles) {
    // Set the file in the state
    setPollution(selectedFiles);
  handleChange({
    target: {
      name: "pollutiondocument",
      value: selectedFiles,
      size: selectedFiles.size,
    },
  });
}
};
const handleFileChangeTax = (event) => {
  const selectedFiles = event.target.files[0];
  if (selectedFiles) {
    // Set the file in the state
    setTax(selectedFiles);
  handleChange({
    target: {
      name: "tax",
      value: selectedFiles,
      size: selectedFiles.size,
    },
  });
}
};
const handleFileChangePan = (event) => {
  const selectedFiles = event.target.files[0];
  if (selectedFiles) {
    // Set the file in the state
    setPan(selectedFiles);
  handleChange({
    target: {
      name: "pandocument",
      value: selectedFiles,
      size: selectedFiles.size,
    },
  });
}
};
const handleFileChangeRc = (event) => {
  const selectedFiles = event.target.files[0];
  if (selectedFiles) {
    // Set the file in the state
    setRc(selectedFiles);
  handleChange({
    target: {
      name: "rcdocument",
      value: selectedFiles,
      size: selectedFiles.size,
    },
  });
}
};
const handleFileChangeOther = (event) => {
  const selectedFiles = event.target.files[0];
  if (selectedFiles) {
    // Set the file in the state
    setOther(selectedFiles);
  handleChange({
    target: {
      name: "otherdocument",
      value: selectedFiles,
      size: selectedFiles.size,
    },
  });
}
};
const handleFileChangepermit = (event) => {
  const selectedFiles = event.target.files[0];
  if (selectedFiles) {
    // Set the file in the state
    setPermit(selectedFiles);
  handleChange({
    target: {
      name: "permitdocument",
      value: selectedFiles,
      size: selectedFiles.size,
    },
  });
}
};
const handleFileChangeinsurance = (event) => {
  const selectedFiles = event.target.files[0];
  if (selectedFiles) {
    // Set the file in the state
    setInsurance(selectedFiles);
  handleChange({
    target: {
      name: "insurancedocument",
      value: selectedFiles,
      size: selectedFiles.size,
    },
  });
}
};
const handleFileChangeFitness = (event) => {
  const selectedFiles = event.target.files[0];
  if (selectedFiles) {
    // Set the file in the state
    setFitness(selectedFiles);
  handleChange({
    target: {
      name: "fitnessdocument",
      value: selectedFiles,
      size: selectedFiles.size,
    },
  });
}
};
  const [formDataPermit, setFormDataPermit] = useState({
    ownername: "",
    address: "",
    guardianname: "",
    vehicleno: "",
    phoneno: "",
    permittype: "",
    startdate: null,
    expiredate: null,
  });

  const [formDataTax, setFormDataTax] = useState({
    ownername: "",
    address: "",
    guardianname: "",
    vehicleno: "",
    phoneno: "",
    taxtype: "",
    startdate: null,
    expiredate: null,
    chassisno: "",
  });

  const handleDateChange = (date, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: date,
    });
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    // if (name === "insurencedocument") {
    //   const uploadedFile = files[0];
    //   if (uploadedFile && uploadedFile.type !== "application/pdf") {
    //     // Display error message for non-PDF files
    //     alert("Please upload only PDF documents.");
    //     // Optionally, you can clear the input field after displaying the error
    //     e.target.value = null;
    //   } else {
    //     // Set the state only if the uploaded file is a PDF
    //     setFormData({
    //       ...formData,
    //       [name]: uploadedFile, // Store the file object in state
    //     });
    //   }
    // } else {
      setFormData({
        ...formData,
        [name]: value,
      });
   // }
  };

  const handleBusinessTypeChange = (event) => {
    const selectedType = event.target.value;
    setBusinessType(selectedType);

    // Show respective forms based on selected business type
    setShowInsuranceForm(selectedType === "insurance");
    setShowFitnessForm(selectedType === "fitness");
    setShowPermitForm(selectedType === "permit");
    setShowPollutionForm(selectedType === "pollution");
    setShowTaxForm(selectedType === "tax");
  };

  const handleSubmitInsurance = async (e) => {
    e.preventDefault();

    try {
      const formDataToSend = new FormData();
      
      formDataToSend.append("formData", JSON.stringify(formData));
      console.log(JSON.stringify(formData))
      formDataToSend.append("pandocument", pan);
      formDataToSend.append("adhardocument", adhardocument);
      formDataToSend.append("rcdocument", Rc);
      formDataToSend.append("otherdocument", other);
      formDataToSend.append("insurancedocument", insurance);
      console.log( adhardocument)
      console.log( pan)
      // for (const [key, value] of Object.entries(formData)) {
      //   if (
      //     key === "registrationdate" ||
      //     key === "startdate" ||
      //     key === "expiredate"
      //   ) {
      //     formDataToSend.append(key, value ? value.toISOString() : null);
      //   } else if (key === "insurencedocument") {
      //     formDataToSend.append(key, value);
      //   } else {
      //     formDataToSend.append(key, value || "");
      //   }
      // }

      const response = await axiosInstance.post(
        "/api/addClientRegistration",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );

      if (response.status === 201) {
        setSuccessMessage("Form submitted successfully!");
        setOpenSuccess(true);

        setTimeout(() => {
          setOpenSuccess(false);
          setSuccessMessage("");
        }, 3000);

        //Clear the file input after successful form submission
        // const fileInput = document.querySelector(
        //   'input[name="insurencedocument"]'
        // );
        // fileInput.value = null;

        setFormData({
          ownername: "",
          address: "",
          guardianname: "",
          vehicleno: "",
          phoneno: "",
          registrationno: "",
          registrationdate: null,
          ncb: "",
          cd: "",
          engineno: "",
          chassisno: "",
          odpremium: "",
          netpremium: "",
          finalpremium: "",
          policyno: "",
          idvvalue: "",
          macmodule: "",
          startdate: null,
          expiredate: null,
          penality: "",
          // insurencedocument: null,
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleSubmitFitness = async (e) => {
    e.preventDefault();

    try {
      // const formDataToSend = {
      //   ...formData,
      //   // permittype: formDataPermit.permitType || "",
      //   registrationdate: formData.registrationdate
      //     ? formData.registrationdate.toISOString()
      //     : null,
      //   startdate: formData.startdate ? formData.startdate.toISOString() : null,
      //   expiredate: formData.expiredate
      //     ? formData.expiredate.toISOString()
      //     : null,
      // };
      const formDataToSend = new FormData();
      
      formDataToSend.append("formData", JSON.stringify(formData));
      console.log(JSON.stringify(formData))
      formDataToSend.append("pandocument", pan);
      formDataToSend.append("adhardocument", adhardocument);
      formDataToSend.append("rcdocument", Rc);
      formDataToSend.append("otherdocument", other);
      formDataToSend.append("fitnessdocument", fitness);
      console.log( adhardocument)
      console.log( pan)
      const response = await axiosInstance.post(
        "/api/addClientFitnessRegistration",
        formDataToSend
      );

      if (response.status === 201) {
        setSuccessMessage("Form submitted successfully!");
        setOpenSuccess(true);

        setTimeout(() => {
          setOpenSuccess(false);
          setSuccessMessage("");
        }, 3000);

        setFormData({
          ownername: "",
          vehicleno: "",
          engineno: "",
          chassisno: "",
          guardianname: "",
          startdate: null,
          expiredate: null,
        });
        setFormDataPermit({ permitType: "" }); // Clear permitType
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleSubmitPermit = async (e) => {
    e.preventDefault();

    try {
      const formDataTopermit = {
        ...formData,
        permittype: formDataPermit.permitType || "", // Ensure permittype is added
        registrationdate: formData.registrationdate
          ? formData.registrationdate.toISOString()
          : null,
        startdate: formData.startdate ? formData.startdate.toISOString() : null,
        expiredate: formData.expiredate
          ? formData.expiredate.toISOString()
          : null,
      };
      const formDataToSend = new FormData();
      
      formDataToSend.append("formData", JSON.stringify(formDataTopermit));
      console.log(JSON.stringify(formDataTopermit))
      formDataToSend.append("pandocument", pan);
      formDataToSend.append("adhardocument", adhardocument);
      formDataToSend.append("rcdocument", Rc);
      formDataToSend.append("otherdocument", other);
      formDataToSend.append("permitdocument", permit);
      console.log( adhardocument)
      console.log( pan)
      const response = await axiosInstance.post(
        "/api/addClientPermitRegistration",
        formDataToSend
      );

      if (response.status === 201) {
        setSuccessMessage("Form submitted successfully!");
        setOpenSuccess(true);

        setTimeout(() => {
          setOpenSuccess(false);
          setSuccessMessage("");
        }, 3000);

        setFormData({
          ownername: "",
          address: "",
          guardianname: "",
          vehicleno: "",
          phoneno: "",
          permittype: "",
          startdate: null,
          expiredate: null,
        });
        setFormDataPermit({ permitType: "" }); // Clear permitType
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleSubmitPollution = async (e) => {
    e.preventDefault();

    try {
      const formDataTopollution = {
        ...formData,
        pollutionType: pollutionType,
        registrationdate: formData.registrationdate
          ? formData.registrationdate.toISOString()
          : null,
        startdate: formData.startdate ? formData.startdate.toISOString() : null,
        expiredate: formData.expiredate
          ? formData.expiredate.toISOString()
          : null,
      };
      const formDataToSend = new FormData();
      
      formDataToSend.append("formData", JSON.stringify(formDataTopollution));
      console.log(JSON.stringify(formDataTopollution))
      formDataToSend.append("pandocument", pan);
      formDataToSend.append("adhardocument", adhardocument);
      formDataToSend.append("rcdocument", Rc);
      formDataToSend.append("otherdocument", other);
      formDataToSend.append("pollutiondocument", pollution);
      console.log( adhardocument)
      console.log( pan)
     
      const response = await axiosInstance.post(
        "/api/addClientPollutionRegistration",
        formDataToSend
      );

      if (response.status === 201) {
        setSuccessMessage("Form submitted successfully!");
        setOpenSuccess(true);

        setTimeout(() => {
          setOpenSuccess(false);
          setSuccessMessage("");
        }, 3000);

        setFormData({
          ownername: "",
          address: "",
          guardianname: "",
          vehicleno: "",
          phoneno: "",
          registrationno: "",
          pollutiontype: "",
          registrationdate: "",
          startdate: null,
          expiredate: null,
        });
        setPollutionType("");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleSubmitTax = async (e) => {
    e.preventDefault();

    try {
      const formDataToTax = {
        ...formData,

        taxType: formDataTax.taxType,
        startdate: formData.startdate ? formData.startdate.toISOString() : null,
        expiredate: formData.expiredate
          ? formData.expiredate.toISOString()
          : null,
      };
      const formDataToSend = new FormData();
      formDataToSend.append("formData", JSON.stringify(formDataToTax ));
      console.log(JSON.stringify(formDataToTax ))
      formDataToSend.append("pandocument", pan);
      formDataToSend.append("adhardocument", adhardocument);
      formDataToSend.append("rcdocument", Rc);
      formDataToSend.append("otherdocument", other);
      formDataToSend.append("taxdocument", tax);
      console.log( adhardocument)
      console.log( pan)
      const response = await axiosInstance.post(
        "/api/addClientTaxRegistration",
        formDataToSend
      );

      if (response.status === 201) {
        setSuccessMessage("Form submitted successfully!");
        setOpenSuccess(true);

        setTimeout(() => {
          setOpenSuccess(false);
          setSuccessMessage("");
        }, 3000);

        setFormData({
          ownername: "",
          address: "",
          guardianname: "",
          vehicleno: "",
          phoneno: "",
          taxtype: "",
          startdate: null,
          expiredate: null,
          chassisno: "",
        });
        setTaxType("");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handlePermitFormChange = (e) => {
    const { name, value } = e.target;
    setFormDataPermit({
      ...formDataPermit,
      [name]: value,
    });
  };

  const handlePollutionTypeChange = (e) => {
    setPollutionType(e.target.value);
  };

  const handleTaxFormChange = (e) => {
    const { name, value } = e.target;
    setFormDataTax({
      ...formDataTax,
      [name]: value,
    });
  };

  useEffect(() => {
    // Code that you would have placed in componentWillMount
    // This will run once when the component mounts
    // Example: Fetching initial data or other side effects
    // Ensure to manage any cleanup if required
  }, []);

  return (
    <>
      <Grid container item xs={12}>
        <Grid item xs={8}>
          <Typography variant="h5" align="left">
            Client Details
          </Typography>
        </Grid>
        {/* <Grid item xs={4} className="text-end">
          <EditIcon />
        </Grid> */}
      </Grid>

      <Grid container>
        <Grid container item xs={12} className="mt-3">
          <Grid item xs={2}>
            <Typography variant="h6" align="left">
              Service Types
            </Typography>
          </Grid>
          <Grid item xs={10}>
            <FormControl>
              <Select
                value={businessType}
                onChange={handleBusinessTypeChange}
                fullWidth
                size="small"
              >
                <MenuItem value="insurance">Insurance</MenuItem>
                <MenuItem value="fitness">Fitness</MenuItem>
                <MenuItem value="permit">Permit</MenuItem>
                <MenuItem value="pollution">Pollution</MenuItem>
                <MenuItem value="tax">Tax</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {showInsuranceForm && (
          <form onSubmit={handleSubmitInsurance}>
            <Grid container spacing={3} className="mt-2">
              {/* Divider line */}
              <Grid item xs={12}>
                <Box>
                  <Divider
                    variant="fullWidth"
                    style={{ backgroundColor: "black" }}
                  />
                </Box>
              </Grid>

              {/* -----------input fields---------------------------------------- */}
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Owner Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="ownername"
                      value={formData.ownername}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Address</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      size="small"
                      fullWidth
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Guardian Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="guardianname"
                      value={formData.guardianname}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Vehicle Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="vehicleno"
                      value={formData.vehicleno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Phone Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="phoneno"
                      value={formData.phoneno}
                      size="small"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">
                      Registration Number
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="registrationno"
                      value={formData.registrationno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Registration Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">
                      Registration Date
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.registrationdate}
                        onChange={(date) =>
                          handleDateChange(date, "registrationdate")
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">NCB</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="ncb"
                      value={formData.ncbcd}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">CD</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="cd"
                      value={formData.ncbcd}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Engine Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="engineno"
                      value={formData.engineno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Chassis Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="chassisno"
                      value={formData.chassisno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Od Premium</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="odpremium"
                      value={formData.odpremium}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Net Premium</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="netpremium"
                      value={formData.netpremium}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Final Premium</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="finalpremium"
                      value={formData.finalpremium}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Policy Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="policyno"
                      value={formData.policyno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">IDV Value</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="idvvalue"
                      value={formData.idvvalue}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Make Module</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="macmodule"
                      value={formData.macmodule}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Penality</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="penality"
                      value={formData.penality}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Start Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Start Date</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.startdate}
                        onChange={(date) => handleDateChange(date, "startdate")}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              {/* Expire Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Expire Date</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.expiredate}
                        onChange={(date) =>
                          handleDateChange(date, "expiredate")
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              {/* Document Upload */}
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Pan</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="insurencedocument"
                      onChange={ handleFileChangePan}
                    />
                  </Grid>
                </Grid>
              </Grid>
      {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Aadhar</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="adhardocument"
                      onChange={handleFileChangeAdhar}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Rc</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="rcdocument"
                      onChange={handleFileChangeRc}
                    />
                  </Grid>
                </Grid>
              </Grid>

               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Insurance</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="insurancedocument"
                      onChange={handleFileChangeinsurance}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Other Document</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="otherdocument"
                      onChange={handleFileChangeOther}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* ----------- Insurence Submit ---------------------------------------- */}

              <Grid item xs={12} className="text-center mt-5">
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
        {showFitnessForm && (
          <form onSubmit={handleSubmitFitness}>
            <Grid container spacing={3} className="mt-2">
              {/* Divider line */}
              <Grid item xs={12}>
                <Box>
                  <Divider
                    variant="fullWidth"
                    style={{ backgroundColor: "black" }}
                  />
                </Box>
              </Grid>

              {/* -----------input fields---------------------------------------- */}
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Owner Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="ownername"
                      value={formData.ownername}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Vehicle Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="vehicleno"
                      value={formData.vehicleno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Engine Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="engineno"
                      value={formData.engineno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Chassis Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="chassisno"
                      value={formData.chassisno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Start Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Start Date</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.startdate}
                        onChange={(date) => handleDateChange(date, "startdate")}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              {/* Expire Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Expire Date</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.expiredate}
                        onChange={(date) =>
                          handleDateChange(date, "expiredate")
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Guardian Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="guardianname"
                      value={formData.guardianname}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Pan</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="insurencedocument"
                      onChange={ handleFileChangePan}
                    />
                  </Grid>
                </Grid>
              </Grid>
      {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Aadhar</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="adhardocument"
                      onChange={handleFileChangeAdhar}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Rc</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="rcdocument"
                      onChange={handleFileChangeRc}
                    />
                  </Grid>
                </Grid>
              </Grid>

               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Fitness</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="fitnessdocument"
                      onChange={handleFileChangeFitness}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Other Document</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="otherdocument"
                      onChange={handleFileChangeOther}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* ----------- Fiteness Submit ---------------------------------------- */}

              <Grid item xs={12} className="text-center mt-5">
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
        {showPermitForm && (
          <form onSubmit={handleSubmitPermit}>
            <Grid container spacing={3} className="mt-2">
              {/* Divider line */}
              <Grid item xs={12}>
                <Box>
                  <Divider
                    variant="fullWidth"
                    style={{ backgroundColor: "black" }}
                  />
                </Box>
              </Grid>

              {/* -----------input fields---------------------------------------- */}
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Owner Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="ownername"
                      value={formData.ownername}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Address</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      size="small"
                      fullWidth
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Guardian Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="guardianname"
                      value={formData.guardianname}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Vehicle Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="vehicleno"
                      value={formData.vehicleno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Phone Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="phoneno"
                      value={formData.phoneno}
                      size="small"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* ---------------permit type--------------- */}

              <Grid
                container
                item
                xs={12}
                lg={6}
                md={6}
                sm={12}
                alignItems="center"
              >
                <Grid item xs={6}>
                  <Typography align="left">Permit Type</Typography>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <Select
                      value={formDataPermit.permitType || " "}
                      onChange={handlePermitFormChange}
                      fullWidth
                      name="permitType"
                      size="small"
                    >
                      <MenuItem value="" disabled>
                        Select Permit Type
                      </MenuItem>
                      <MenuItem value="1 year">1 year</MenuItem>
                      <MenuItem value="5 years">5 years</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/*Permit Start Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">
                      Permit Start Date
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.startdate}
                        onChange={(date) => handleDateChange(date, "startdate")}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              {/*Permit Expire Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">
                      Permit Expire Date
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.expiredate}
                        onChange={(date) =>
                          handleDateChange(date, "expiredate")
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Pan</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="insurencedocument"
                      onChange={ handleFileChangePan}
                    />
                  </Grid>
                </Grid>
              </Grid>
      {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Aadhar</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="adhardocument"
                      onChange={handleFileChangeAdhar}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Rc</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="rcdocument"
                      onChange={handleFileChangeRc}
                    />
                  </Grid>
                </Grid>
              </Grid>

               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Permit</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="permitdocument"
                      onChange={handleFileChangepermit}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Other Document</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="otherdocument"
                      onChange={handleFileChangeOther}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* ----------- Permit Submit ---------------------------------------- */}

              <Grid item xs={12} className="text-center mt-5">
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
        {showPollutionForm && (
          <form onSubmit={handleSubmitPollution}>
            <Grid container spacing={3} className="mt-2">
              {/* Divider line */}
              <Grid item xs={12}>
                <Box>
                  <Divider
                    variant="fullWidth"
                    style={{ backgroundColor: "black" }}
                  />
                </Box>
              </Grid>

              {/* -----------input fields---------------------------------------- */}
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Owner Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="ownername"
                      value={formData.ownername}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Address</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      size="small"
                      fullWidth
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Guardian Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="guardianname"
                      value={formData.guardianname}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Vehicle Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="vehicleno"
                      value={formData.vehicleno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Phone Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="phoneno"
                      value={formData.phoneno}
                      size="small"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">
                      Registration Number
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="registrationno"
                      value={formData.registrationno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Registration Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">
                      Registration Date
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.registrationdate}
                        onChange={(date) =>
                          handleDateChange(date, "registrationdate")
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              {/* Start Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Start Date</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.startdate}
                        onChange={(date) => handleDateChange(date, "startdate")}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              {/* Expire Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Expire Date</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.expiredate}
                        onChange={(date) =>
                          handleDateChange(date, "expiredate")
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              {/* ---------------Pollution type--------------- */}

              <Grid
                container
                item
                xs={12}
                lg={6}
                md={6}
                sm={12}
                alignItems="center"
              >
                <Grid item xs={6}>
                  <Typography align="left">Pollution Type</Typography>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <Select
                      value={pollutionType}
                      onChange={handlePollutionTypeChange}
                      fullWidth
                      name="pollutionType"
                      size="small"
                    >
                      <MenuItem value="">Select Pollution Type</MenuItem>
                      <MenuItem value="6 Months">6 Months</MenuItem>
                      <MenuItem value="1 Year">1 Year</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Pan</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="insurencedocument"
                      onChange={ handleFileChangePan}
                    />
                  </Grid>
                </Grid>
              </Grid>
      {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Aadhar</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="adhardocument"
                      onChange={handleFileChangeAdhar}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Rc</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="rcdocument"
                      onChange={handleFileChangeRc}
                    />
                  </Grid>
                </Grid>
              </Grid>

               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Pollution</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="pollutiondocument"
                      onChange={handleFileChangePollution}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Other Document</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="otherdocument"
                      onChange={handleFileChangeOther}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* ----------- Pollution Submit ---------------------------------------- */}

              <Grid item xs={12} className="text-center mt-5">
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
        {showTaxForm && (
          <form onSubmit={handleSubmitTax}>
            <Grid container spacing={3} className="mt-2">
              {/* Divider line */}
              <Grid item xs={12}>
                <Box>
                  <Divider
                    variant="fullWidth"
                    style={{ backgroundColor: "black" }}
                  />
                </Box>
              </Grid>

              {/* -----------input fields---------------------------------------- */}
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Owner Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="ownername"
                      value={formData.ownername}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Address</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      size="small"
                      fullWidth
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Guardian Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="guardianname"
                      value={formData.guardianname}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Vehicle Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="vehicleno"
                      value={formData.vehicleno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Phone Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="phoneno"
                      value={formData.phoneno}
                      size="small"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* ---------------tax type--------------- */}

              <Grid
                container
                item
                xs={12}
                lg={6}
                md={6}
                sm={12}
                alignItems="center"
              >
                <Grid item xs={6}>
                  <Typography align="left">Tax Type</Typography>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <Select
                      value={formDataTax.taxType || ""}
                      onChange={handleTaxFormChange}
                      fullWidth
                      name="taxType"
                      size="small"
                    >
                      <MenuItem value="" disabled>
                        Select Tax Type
                      </MenuItem>
                      <MenuItem value="3 Month">3 Month</MenuItem>
                      <MenuItem value="1 year">1 years</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* Tax Start Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Tax Start Date</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.startdate}
                        onChange={(date) => handleDateChange(date, "startdate")}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              {/*Tax Expire Date */}
              <Grid item xs={12} lg={6} md={6} sm={12} className="">
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Tax Expire Date</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.expiredate}
                        onChange={(date) =>
                          handleDateChange(date, "expiredate")
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Chassis Number</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      name="chassisno"
                      value={formData.chassisno}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Pan</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="insurencedocument"
                      onChange={ handleFileChangePan}
                    />
                  </Grid>
                </Grid>
              </Grid>
      {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Aadhar</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="adhardocument"
                      onChange={handleFileChangeAdhar}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Rc</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="rcdocument"
                      onChange={handleFileChangeRc}
                    />
                  </Grid>
                </Grid>
              </Grid>

               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Tax</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="taxdocument"
                      onChange={handleFileChangeTax}
                    />
                  </Grid>
                </Grid>
              </Grid>
               {/* Document addar Upload */}
      <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
                <Grid container alignItems="center">
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Typography variant="subtitle1">Other Document</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <input
                      type="file"
                      accept=".pdf"
                      name="otherdocument"
                      onChange={handleFileChangeOther}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* ----------- Tax Submit ---------------------------------------- */}

              <Grid item xs={12} className="text-center mt-5">
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Grid>

      {/* Success Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSuccess}
        autoHideDuration={3000}
        onClose={handleSuccessClose}
        message={successMessage}
      />
    </>
  );
};

export default ClientRegistration;
